import { combineReducers } from "redux";

import ratingreviews from "../features/admin/rating_review/Slice";


const rating_review = combineReducers({
  ratingreviews,
});

export default rating_review;
